<template>
  <div class="page">
    <PageHeader :links="headLinks" />

    <div class="pageMain">
      <el-row>
        <el-col :span="24">
          <el-form class="searchForm" ref="form" :model="form" label-width="90px" style="margin-top: 20px">
            <el-col :md="12" :lg="8" :xl="7">
              <el-form-item label="投稿时间">
                <el-date-picker style="width: 100%" type="daterange" :default-time="['00:00:00', '23:59:59']" start-placeholder="开始日期" end-placeholder="结束日期" v-model="form.createTime" format="yyyy年MM月dd日" value-format="yyyy-MM-dd H:m:s"></el-date-picker>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="8" :xl="8">
              <el-form-item label="稿件标题">
                <el-input placeholder="模糊检索" v-model="form.title"></el-input>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="5" :xl="7">
              <el-form-item label="稿件作者">
                <el-input placeholder="模糊检索" v-model="form.authorName"></el-input>
              </el-form-item>
            </el-col>

            <el-col :md="12" :lg="3" :xl="2">
              <div style="float: left; margin-left: 20px">
                <el-button type="primary" @click="loadData">搜索</el-button>
              </div>
            </el-col>
          </el-form>

          <div style="padding: 20px 0">
            <el-button type="primary" :disabled="!flag" @click="downloadAttach">批量导出稿件附件</el-button>
            <el-button type="warning" :disabled="!flag" @click="outputLicense">批量导出著作权协议书</el-button>
            <el-button type="success" :disabled="!flag" @click="exportXLS">批量导出稿件记录表</el-button>
          </div>

          <el-table ref="tableData" :data="tableData" @select-all="selAll" @selection-change="selChange" stripe style="width: 100%">
            <el-table-column type="selection" width="55"> </el-table-column>
            <el-table-column type="index" width="40" align="center"> </el-table-column>
            <el-table-column prop="sn" label="稿件编号" align="center" width="90"></el-table-column>
            <el-table-column prop="title" label="稿件标题"></el-table-column>
            <el-table-column prop="authorName" label="作者" width="90"></el-table-column>
            <el-table-column prop="createTime" align="center" label="投稿时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.createTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>
            <el-table-column prop="dcTime" align="center" label="录取时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.dcTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>
            <el-table-column prop="letterNoticePage" align="center" label="拟占用版面数" width="70"></el-table-column>
            <el-table-column prop="issueCost" align="center" label="应收出版费" width="70"></el-table-column>
            <el-table-column prop="letterNoticeTime" align="center" label="拟发表时间" width="70"></el-table-column>
            <el-table-column prop="orderSn" label="订单编号" width="160"></el-table-column>
            <el-table-column prop="payAmount" label="实收金额" width="70"></el-table-column>
            <el-table-column prop="payTime" align="center" label="收款时间" width="120">
              <template slot-scope="scope">
                {{ scope.row.payTime | datefmt2("YYYY-MM-DD HH:mm") }}
              </template>
            </el-table-column>
            <el-table-column prop="paySn" align="center" label="支付编号" width="160"> </el-table-column>
          </el-table>
          <div style="margin: 20px 0 0 -5px">
            <el-pagination background layout="sizes,prev, pager, next" :page-sizes="[10, 20, 30, 50, 100]" :total="total" :page-size="pageSize" :current-page="curPage" @current-change="pageChange" @size-change="pageSizeChange"> </el-pagination>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue"
import articleApi from "@/api/article"
import recheckApi from "@/api/recheck"
import attachUtil from "@/utils/attachUtil"
export default {
  components: { PageHeader },
  data() {
    return {
      tabActive: "first",
      headLinks: [{ path: "", title: "已录用稿件" }],
      form: {
        authorName: "",
        paySn: "",
        createTime: [],
        payAmountRange: [],
        payTimeRange: [],
        title: "",
        f_subjectId: -1,
      },
      flag: false,

      curPage: 1,
      pageSize: 10,
      tableData: [],
      total: 0,

      drawer: false,
      drawerTitle: "填写发票信息",
      drawerAction: "add",
      invoiceId: null,
    }
  },

  computed: {},

  mounted() {
    this.loadData()
  },

  methods: {
    loadData() {
      this.tableData = []
      articleApi.articleEmployedList(this.curPage, this.pageSize, "optTime", "desc", this.form, 2).then((res) => {
        this.tableData = res.rows
        this.total = res.total
      })
    },
    getSelectionIds() {
      let selRows = this.$refs.tableData.selection
      let ids = []
      selRows.forEach((element) => {
        ids.push(element.id)
      })
      return ids
    },
    downloadAttach() {
      let ids = this.getSelectionIds()
      articleApi.downloadAttachEmployed(ids).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败", "错误", {
            confirmButtonText: "确定",
          })
        } else {
          attachUtil.download(res, "已收录稿件附件.zip")
        }
      })
    },
    exportXLS() {
      let ids = this.getSelectionIds()
      articleApi.exportXlsEmployed(ids).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败", "错误", {
            confirmButtonText: "确定",
          })
        } else {
          attachUtil.download(res, "已收录稿件记录表.xls")
        }
      })
    },

    outputLicense() {
      let selRows = this.$refs.tableData.selection
      let articleIds = []
      selRows.forEach((element) => {
        articleIds.push(element.id)
      })

      recheckApi.downloadLicense(articleIds).then((res) => {
        if (res.type != "application/octet-stream") {
          this.$alert("下载失败", "错误", {
            confirmButtonText: "确定",
          })
        } else {
          attachUtil.download(res, "稿件著作权授权书.zip")
        }
      })
    },

    closeDrawer() {
      this.drawer = false
    },

    openDrawer(id, action) {
      this.invoiceId = id
      this.drawer = true
      this.drawerAction = action
      this.drawerTitle = this.drawerAction == "edit" ? "编辑开票信息" : "查看开票信息"
    },

    selAll() {
      this.flag = this.$refs.tableData.selection.length > 0
    },
    selChange() {
      this.flag = this.$refs.tableData.selection.length > 0
    },

    pageChange(curPage) {
      this.curPage = curPage
      this.loadData()
    },

    pageSizeChange(val) {
      this.pageSize = val
      this.curPage = 1
      this.loadData()
    },
  },
}
</script>
